import { ValidationResult } from "../../Utils/Interfaces";

export function doNothing(): void {
    // do nothing
}

export default function (): void {
    // can't be empty
}

const UP_DOWN_REQUIRED_KEY = "ticket_style";

export const UseUpDownTimes = (): boolean => {
    return (localStorage.getItem(UP_DOWN_REQUIRED_KEY) || "N") === "Y";
};

export function SaveUpDownTimesMode(value: number): void {
    localStorage.setItem(UP_DOWN_REQUIRED_KEY, value === 1 ? "Y" : "N");
}

export function getErrorMessagesForProperty(validationMessages: ValidationResult[], detailUrl: string, entityId: number, propertyName: string): ValidationResult[] {
    const messages = validationMessages.filter((validation) => {
        return validation.editCard === detailUrl && validation.entityId === entityId && validation.propertyName === propertyName;
    });

    return messages;
}

export function propertyHasErrors(validationMessages: ValidationResult[], detailUrl: string, entityId: number, propertyName: string): boolean {
    return getErrorMessagesForProperty(validationMessages, detailUrl, entityId, propertyName).length > 0;
}

export function getHelperText(validationMessages: ValidationResult[], detailUrl: string, entityId: number, propertyName: string): string {
    const properyMessages = getErrorMessagesForProperty(validationMessages, detailUrl, entityId, propertyName)
        .filter((m) => !m.message.includes("REQUIRED"))
        .map((v) => v.message);
    const result = properyMessages.join("; ");
    return result;
}
